/**
 * 半角英数記号
 */
export default {
  validate(value: string | undefined | null): boolean {
    if (!value) {
      return true;
    }
    return !/[^0-9a-zA-Z -/:-@[-~]/.test(value);
  },
};
